import React from "react";
import NumberFormat from "react-number-format";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";

const Input = styled(NumberFormat)`
  ${({ error, theme }) =>
    error
      ? css`
          border-color: ${theme["@alert"]} !important;
        `
      : ""};
  &:focus {
    box-shadow: none !important;
  }
`;

function CurrencyInput({ onChange, ...props }) {
  const { t } = useTranslation();

  const handleChange = ({ floatValue }) => {
    if (onChange) onChange(floatValue);
  };
  return (
    <Input
      {...props}
      className="ant-input-number"
      style={{ paddingLeft: 10 }}
      thousandSeparator={t("currency:thousandSeparator")}
      decimalSeparator={t("currency:thousandSeparator") === "." ? "," : "."}
      decimalScale="2"
      allowNegative={false}
      onValueChange={handleChange}
    />
  );
}

export default CurrencyInput;
